import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Popover } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import IntlMessages from '../../components/utility/intlMessages';
import TopbarDropdownWrapper from './TopbarDropdown.styles';
import { TopbarNotifyIcon } from '../../config/icon.config';
import sound from '../../assets/sound/notification.mp3';
import notifications from '../../components/Feedback/Notification';
import { webAppNotificationPolling } from '../../services/webAppNotification';
import { changeFetching } from '../../redux-new/notification-fetch/notification-fetch.slice';
import { changeClick } from '../../redux-new/notification-click/notification-click.slice';
import { resetIdOperator } from '../../redux-new/notification-set-operator/notification-set-operator.slice';
import { getAuthenticateData } from '../../library/helpers/utility';

const REFRESH_DATA_INTERVAL = 10 * 1000; // periodo di update della callback

const openNotification = (type, message, description) => {
  notifications[type]({
    message: message,
    description: description,
  });
};

export default function TopbarNotification() {
  const [visible, setVisiblity] = React.useState(false);
  const customizedTheme = useSelector(
    (state) => state.themeSwitcher.topbarTheme
  );
  const refreshCallback = useRef();
  const [appointmentNotifications, setAppointmentNotifications] =
    useState(null);
  const dispatch = useDispatch();
  const idOperator = useSelector(
    (state) => state.notificationSetOperator.idOperator
  );

  const [clickedNotification, setClickedNotification] = useState(null);
  const [idOperatorRedux, setIdOperatorRedux] = useState(null);

  function handleVisibleChange() {
    setVisiblity((visible) => !visible);
  }

  const fetchData = useCallback(async () => {
    let resp = [];

    try {
      const [appointmentNotificationsResp] = await Promise.all([
        webAppNotificationPolling(
          idOperatorRedux !== null && idOperatorRedux !== undefined
            ? idOperatorRedux
            : getAuthenticateData().authenticate.scaAccount.id
        ),
      ]);

      const newNotifications = appointmentNotificationsResp.data.contentData;
      resp = newNotifications;

      if (newNotifications && newNotifications.length > 0) {
        setAppointmentNotifications((prevNotifications) => {
          if (!prevNotifications || prevNotifications.length === 0) {
            return newNotifications;
          }

          const existingIds = new Set(
            prevNotifications.map((n) => n.idAppointment)
          );
          const uniqueNewNotifications = newNotifications.filter(
            (n) => !existingIds.has(n.idAppointment)
          );

          return [...uniqueNewNotifications, ...prevNotifications];
        });

        let audioElement = document.createElement('AUDIO');
        document.body.appendChild(audioElement);
        audioElement.src = sound;

        newNotifications.forEach((item) => {
          openNotification(
            item.appointmentStatus === 'Annullato cliente' ||
              item.appointmentStatus === 'Annullato operatore' ||
              item.appointmentStatus === 'Utente cancellato'
              ? 'warning'
              : 'success',
            item.customerName + ' ' + item.datetime,
            item.duties
          );
        });

        audioElement.addEventListener('canplaythrough', async () => {
          await audioElement.play();
        });

        dispatch(changeFetching());
      }
    } catch (err) {
      openNotification(
        'error',
        'Operazione fallita',
        `Caricamento notifiche fallito`
      );
    }
  }, [idOperatorRedux, dispatch]);

  /* Gestione del refresh - aggiornamento callback ad ogni re-render del component */
  const refreshData = useCallback(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    refreshCallback.current = refreshData;
  });
  /* ****************************************************************************** */

  useEffect(() => {
    fetchData();

    // Creazione callback da invocare alla scadenza del timer
    function tickCallback() {
      refreshCallback.current();
    }
    const interval = setInterval(tickCallback, REFRESH_DATA_INTERVAL);

    return () => clearInterval(interval);

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (clickedNotification !== null) {
      setAppointmentNotifications((appointmentNotifications) =>
        appointmentNotifications.filter(
          (data) => data.idAppointment !== clickedNotification
        )
      );
      setVisiblity(false);
    }

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clickedNotification]);

  const resetAppointmentNotification = () => {
    setAppointmentNotifications([]);
  };

  useEffect(() => {
    if (idOperator !== null) {
      setIdOperatorRedux(idOperator);
    }

    //dispatch(resetIdOperator());

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idOperator]);

  const content = (
    <TopbarDropdownWrapper className="topbarNotification">
      <div className="isoDropdownHeader">
        <audio hidden id="audio" src={sound} preload="metadata"></audio>
        <h3>
          <IntlMessages id="sidebar.notification" />
        </h3>
      </div>
      <div className="isoDropdownBody">
        {appointmentNotifications?.length > 0 ? (
          appointmentNotifications.map((notification) => (
            <div
              className="isoDropdownListItem"
              key={notification.idAppointment}
              onClick={() => {
                dispatch(
                  changeClick({ isClick: true, date: notification.datetime })
                );
                setClickedNotification(notification.idAppointment);
              }}
            >
              <h5>{notification.customerName + ' ' + notification.datetime}</h5>
              <p>{notification.duties}</p>
            </div>
          ))
        ) : (
          <p className="isoDropdownListItem">Nessuna Notifica</p>
        )}
      </div>
      <a
        className="isoViewAllBtn"
        href="# "
        onClick={resetAppointmentNotification}
      >
        <IntlMessages id="topbar.deleteAll" />
      </a>
    </TopbarDropdownWrapper>
  );
  return (
    <Popover
      content={content}
      trigger="click"
      visible={visible}
      onVisibleChange={handleVisibleChange}
      placement="bottomLeft"
    >
      <div className="isoIconWrapper">
        <TopbarNotifyIcon size={24} color={customizedTheme.textColor} />
        <span>
          {appointmentNotifications ? appointmentNotifications.length : 0}
        </span>
      </div>
    </Popover>
  );
}
